import _ from 'lodash';
import getGoodiesOfType from './getGoodiesOfType';


function shuffleGoodyOfType(collectedGoodies, type) {
	const collectedGoodiesOfType = getGoodiesOfType(collectedGoodies, type);

	if (_.isEmpty(collectedGoodiesOfType)) {
		return null;
	}

	return collectedGoodiesOfType[_.random(collectedGoodiesOfType.length * 2)];
}

function shuffleActiveGoodies(collectedGoodies) {
	return {
		glasses: shuffleGoodyOfType(collectedGoodies, 'glasses'),
		hat: shuffleGoodyOfType(collectedGoodies, 'hat'),
		toy: shuffleGoodyOfType(collectedGoodies, 'toy'),
	};
}

export default shuffleActiveGoodies;



// WEBPACK FOOTER //
// ./src/utils/shuffleActiveGoodies.js